const $window = $(window);
let windowWidth = $window.width();

// メディアクエリ
let mql = window.matchMedia('screen and (max-width: 1024px)');

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//相関図アンカー
import {anchorScroll} from "../include/module";
anchorScroll();


$(window).on('load' , function() {

  setTimeout(function(){$('#st-Loader .loader').addClass("load");},0);
  setTimeout(function(){$('#st-Loader').addClass("hidden");},300);
  setTimeout(function(){$('#st-Loader').remove();},2000);
  setTimeout(function(){$('.js-loadingAnimation').addClass("is-animated");},500);

  charaModal();
  charaChange();
  scrollCommonAnime();

});


// ------------------------------------------------------------------------
// scrollCommonAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollCommonAnime = () => {

  const controller = new ScrollMagic.Controller();
  // const targets = document.querySelectorAll(".js-scrollAnimation");
  // const targetsArray = Array.prototype.slice.call(targets); //Array
  // targetsArray.forEach(target => {
  // //シーンを作成
  // const scene = new ScrollMagic.Scene({
  //     triggerElement: target,
  //     triggerHook: .8
  //   })
  //   .setClassToggle(target, "is-animated")
  //   .addTo(controller);
  // });

  //ロゴ出現

  //道出現
  const scene = new ScrollMagic.Scene({
    triggerElement:'#st-Footer',
    triggerHook: 1,
    offset: '-300'
  })
  .setClassToggle('#road', 'road-Show2')
  // .addIndicators()
  .addTo(controller);

  //　スクロールで発火系
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
    const scene2 = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .9
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

};

// ------------------------------------------------------------------------
// smoke
// ----- BOTH
// ------------------------------------------------------------------------
// smoke
const smoke = (target) => {
  var elm   = document.getElementById(target);
  var elmWidth = elm.clientWidth;
  var elmHeight = elm.clientHeight;
  var app = new PIXI.Application(windowWidth, elmHeight, {transparent : true});
  elm.appendChild(app.view);
  app.stage.interactive = true;

  var container = new PIXI.Container();
  app.stage.addChild(container);

  var flag = PIXI.Sprite.fromImage("/wordpress/wp-content/themes/road_teaser/assets/images/common/bg_smoke.png");
  container.addChild(flag);
  flag.x = 0;
  flag.y = 0;
  flag.width = app.renderer.width;
  flag.height = app.renderer.height;

  var displacementSprite = PIXI.Sprite.fromImage('/wordpress/wp-content/themes/road_teaser/assets/images/common/displacement_map_repeat.jpg');
  //Make sure the sprite is wrapping.
  displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
  var displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);
  displacementFilter.padding = 0;

  displacementSprite.position = flag.position;

  app.stage.addChild(displacementSprite);

  flag.filters = [displacementFilter];

  displacementFilter.scale.x = app.renderer.width * 1;
  displacementFilter.scale.y = app.renderer.height * 1;

  app.ticker.add(function() {
  	//Offset the sprite position to make vFilterCoord update to larger value. Repeat wrapping makes sure there's still pixels on the coordinates.
  	displacementSprite.x++;
  	//Reset x to 0 when it's over width to keep values from going to very huge numbers.
  	if(displacementSprite.x > displacementSprite.width)
  		displacementSprite.x = 0;
  });

  $(window).on("load resize", function () {
    app.renderer.resize(elm.clientWidth, elm.clientHeight);
    flag.width = app.renderer.width;
    flag.height = app.renderer.height;
  });
};
smoke('smoke');


// ------------------------------------------------------------------------
// charaModal();
// ----- BOTH
// ------------------------------------------------------------------------
const charaModal = () => {

  const $modal = $('#character-cast_Stage');
  const $modalClose = $('#character-cast_Stage_Close, #CloseSP');
  const $modalPrev = $('#character-cast_Stage_Prev');
  const $modalNext = $('#character-cast_Stage_Next');
  const $modalInner = $('#character-cast_Stage_Inner');

  let scrollPosition;
  const ua = window.navigator.userAgent.toLowerCase();
  const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
  const body = document.querySelector('body');

  var _currentNum;
  var _oldNum;
  var ALL_NUM;
  ALL_NUM = $('.character-cast_Stage_Inner_Profile').length;
  var posi;


  // タブのパラメータがついている時の対応
  var param = getParam('id');
  if(param != null){
    if($('[data-modal-content="' + param + '"]').length > 0) {
      modalOpen(param);
    }
  }

  // 一覧から開く
  $(document).on('click', '[data-modal-link]', function(e) {
    e.preventDefault();
    var target = $(this).data('modalLink');
    modalOpen(target);
  });

  // 閉じるボタン
  $modalClose.on('click', function(e) {
      e.preventDefault();
      modalClose();
  });

  function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
	}



  // モーダルを開く
  function modalOpen(target) {

    // モーダルが開いたら、bodyにfixedを付与
    bodyFixedOn();

    $('[data-modal-content = ' + target + ']').addClass('is-show');
    $modal.addClass('opened');
    _currentNum = $('[data-modal-content = ' + target + ']').data('modal-num');
    _oldNum = _currentNum;

    // パラメータ付与
    let setParam = '?id=' + target;
    history.pushState(null, null, setParam);

    // モーダルのスクロール位置上に
    scrollChara();

  }

  // モーダルを閉じる
  function modalClose() {
    $('[data-modal-content]').removeClass('is-show');
    $modal.removeClass('opened');

    // パラメータ初期化
    history.pushState(null, null, '/character-cast/');

    // モーダルが閉じられたら、スクロールのトップを取得してbodyに
    bodyFixedOff();
    charaScale();

  }


  // 前へ切り替えボタン
  $modalPrev.on('click', function() {

    _currentNum--;

    if(_currentNum < 0){
      _currentNum = ALL_NUM-1;
    }

    changeDetail();
    scrollChara();
    charaScale();

  });


  // 次へ切り替えボタン
  $modalNext.on('click', function() {

    // console.log(ALL_NUM)

    _currentNum++;

    if(_currentNum > ALL_NUM-1){
      _currentNum = 0;
    }

    changeDetail();
    scrollChara();
    charaScale();

  });


  // 切り替え
  function changeDetail() {

    var _oldTarget = $('.character-cast_Stage_Inner_Profile').eq(_oldNum);

    let target = $('.character-cast_Stage_Inner_Profile').eq(_currentNum);

    _oldTarget.removeClass("is-show");

    // changeControl();

    target.addClass("is-show");

    _oldNum = _currentNum;

    // パラメータ変更
    var targetId = $(target).data('modal-content');
    // パラメータ付与
    let setParam = '?id=' + targetId;
    history.pushState(null, null, setParam);

  }

  //モーダルのスクロール一番上へ
  function scrollChara() {

    $('#character-cast_Stage,#character-cast_Stage_Inner,.character-cast_Stage_Inner_Profile').scrollTop(0);

  }

    //bodyのスクロール固定
    function bodyFixedOn() {
      if(isiOS){
          scrollPosition = window.pageYOffset;
          body.style.position = 'fixed';
          body.style.top = `-${scrollPosition}px`;
      }else {
          body.style.overflow = 'hidden';
      }
      // body.style.overflow = 'hidden';

  }

  function bodyFixedOff() {
      if(isiOS){
          body.style.removeProperty('position');
          body.style.removeProperty('top');
          window.scrollTo(0, scrollPosition);
      }else {
          body.style.removeProperty('overflow');
      }
      // body.style.removeProperty('overflow');
  }

};


// ------------------------------------------------------------------------
// charaChange();
// ----- BOTH
// ------------------------------------------------------------------------
const $changeBtn = $('.btn-scale');
const $illust = $('.illust');
let _isChange  = false;

const charaChange = () => {

  $changeBtn.on('click', function() {
    if(!_isChange){

      setTimeout(function(){
        //縮小
        charaScaleDown();
      },0);

    } else {

      setTimeout(function(){
         //拡大
        charaScale();
      },0);

    }
  });


};

//縮小
const charaScaleDown = () => {

  $changeBtn.addClass('whole');
  $illust.addClass('whole');
  _isChange = true;

};

//拡大
const charaScale = () => {

  $changeBtn.removeClass('whole');
  $illust.removeClass('whole');
  _isChange = false;

};



// WEBPACK FOOTER //
// ./src/road59_v2/assets/js/character-cast/script.js